import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=f127ff00&scoped=true&"
import script from "./ComingSoon.js?vue&type=script&lang=js&"
export * from "./ComingSoon.js?vue&type=script&lang=js&"
import style0 from "./ComingSoon.scss?vue&type=style&index=0&id=f127ff00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f127ff00",
  null
  
)

export default component.exports